export const YesNo = {
    true: "Oui",
    false: "Non",
};

export const getYesNoOptions = () => {
  return [
    { value: "", label: "Tous" },
    ...Object.entries(YesNo).map(([key, label]) => ({
      value: key,
      label,
    })),
  ];
};
